import React,{useState, useEffect} from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { api, eventURL, WorkshopListURL } from "../../../apis/urls";
import Loader from "../../../common-components/loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";
import moment from "moment/moment";
import { Table, Toggle,Pagination } from "rsuite";
import { Fragment } from "react-read-more-read-less";

const { Column, HeaderCell, Cell } = Table;

const SessionsLising = () => {

    const [added, setAdded] = useState(false);
    const [publish, setPublish] = useState('');

    const [pageno, setPageno] = useState(0);
    const [ename, setEname] = useState('');


    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
            });
    }, []);

    const [loader,setLoader] = useState(true);
    const [result,setResult] = useState([]);


    let counts = 0;
    if(result)
    {
        counts = result.length;
    }

    const {wid} = useParams();

    let navigate = useNavigate();

    const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: WorkshopListURL+'/'+wid,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{

            setEname(response.data.data.title)

            if(response.data.message === "Success"){            
                setResult(response.data.data.sessions.sort((a, b) => b.createdAt.localeCompare(a.createdAt)));
                setLoader(false)
                }else{
                setResult(false);
                setLoader(false);
            }

           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }


   


    let sl =1;
    return (
        <div className="wrapper">
            <aside className="right-side ">
                <div class="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            <i className="icon-suitcase1"></i>
                            <h2 className="page-title">Sessions - {decode(ename)}</h2>
                        </div>

                        <div class="page-rightside-action-column">
                        <Link to={"/workshop/create/"+wid} data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New Session"><i class="icon-add"></i><span>Add New Session</span> </Link>
                    </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/workshop">Conference Manager</Link></li>    
                            <li className="breadcrumb-item active" aria-current="page">Sessions</li>
                        </ol>
				    </nav>

                        {result.length !== 0?
                        (<div class="number-of">
                            Displaying 1-{counts} of {counts} results.
                        </div>):null
                        }


                    <div className="jobs-list-wrpr list-wrpr" >

                        {result?(
                        result?.map((item,index) =>
                            (
   
                                <>


                                <div className="list "  style={{background:item.publish_status === 'UNPUBLISHED'?'#f0f0f0':'#fff'}}>
                                    <div className="row">
                                        <div className="col-md-1">
                                        <div class="jobs-user">
                                        <span class="desig">Sl.No</span>
                                            {sl++}
                                        </div>
                                        </div>
                                        
                                        <div className="col-md-4">
                                            <div className="jobs-user">
                                            <span class="desig"> Session Name</span>

                                            {decode(item.name)}
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="jobs-user">
                                            <span class="desig">Start Time</span>
                                                 {moment(item.start_date).format('MMMM DD, YYYY') +", "+ moment(item.start_date).format('hh:mm A')}
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="jobs-user">
                                            <span class="desig">End Time</span>
                                                 {moment(item.end_date).format('MMMM DD, YYYY') +", "+  moment(item.end_date).format('hh:mm A')}
                                            </div>
                                        </div>


                                    
                                        <div className="col-md-3">
                                            <div className="list-action-wrpr text-right  roundicons-text event-btns">
                                            <button onClick={()=>{navigate("/workshop/session/"+wid+"/"+item.id)}}  style={{backgroundColor:'transparent' }}  data-toggle="tooltip" title="Workshops" ><i className="delete icon-event_available" style={{background:'#0069FF'}}></i><span>Workshop</span></button>
                                            <button onClick={()=>{navigate("/workshop/session/view/"+wid+"/"+item.id)}}  style={{backgroundColor:'transparent', paddingLeft:'10px' }}  data-toggle="tooltip" title="Workshops" ><i className="delete icon-eye" style={{background:'orange'}}></i><span>View</span></button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                           
                           
                           
                           )

                        )):null
                        }
                        {
                            result.length === 0?
                            (
                            <div className="nodata empty-workshop">

                                <Link to={"/workshop/create/"+wid} data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New Session"><i class="icon-add"></i><span>Add New Session</span> </Link>

                            </div>
                            ):null
                        }



                        {result.length !== 0?

                        (<div class="number-of footer-number">
                            Displaying 1-{counts} of {counts} results.
                        </div>):null
                        }
    
                    </div>

                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }


                </div>
            </aside>
        </div>
    )
}

export default SessionsLising;